var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 4,
    fill: "none",
    stroke: "#272726",
    strokeLinejoin: "round",
    className: "start_svg__nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 17h8v8h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-cap": "butt",
    d: "M2 21L24 3l22 18M19 45V33h10v12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 24v17a4 4 0 004 4h26a4 4 0 004-4V24"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHdpZHRoPSIyNCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48dGl0bGU+aG9tZSAyPC90aXRsZT48ZyBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMjcyNzI2IiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibmMtaWNvbi13cmFwcGVyIj48cmVjdCB4PSIyMCIgeT0iMTciIHdpZHRoPSI4IiBoZWlnaHQ9IjgiPjwvcmVjdD48cG9seWxpbmUgZGF0YS1jYXA9ImJ1dHQiIHBvaW50cz0iMiAyMSAyNCAzIDQ2IDIxIiBzdHJva2U9IiMyNzI3MjYiPjwvcG9seWxpbmU+PHBvbHlsaW5lIGRhdGEtY2FwPSJidXR0IiBwb2ludHM9IjE5IDQ1IDE5IDMzIDI5IDMzIDI5IDQ1Ij48L3BvbHlsaW5lPjxwYXRoIGQ9Ik03LDI0djE3YzAsMi4yMDksMS43OTEsNCw0LDRoMjZjMi4yMDksMCw0LTEuNzkxLDQtNFYyNCI+PC9wYXRoPjwvZz48L3N2Zz4=";
export { SvgStart as ReactComponent };